<template>
  <router-view />
</template>

<script>
import $ from "jquery";
import { fetchBalance } from "@/stores/wallet";

export default {
  name: "App",
  mounted() {
    fetchBalance();
  },
};
</script>
